// Copyright (c) StrangeBee 2024

import THTable from '@Molecules/THTable/THTable';
import { ColumnsType } from 'antd/lib/table';
import React, { ReactElement, ReactNode } from 'react';

interface PlatformTableProps<T> {
    dataSource?: any[] | any;
    columns: ColumnsType<T & { thEntityName: string }>;
    loading?: boolean;
    rowKey?: string;
    title?: ReactNode;
}
const PlatformTable = <T,>({
    dataSource = [],
    columns,
    loading = false,
    rowKey = 'thEntityName',
    title,
}: PlatformTableProps<T>): ReactElement => (
    <THTable
        dataSource={
            Array.isArray(dataSource)
                ? dataSource
                : Object.entries(dataSource).map(([thEntityName, dataIndex]: [string, any]) => ({
                      thEntityName,
                      ...dataIndex,
                  }))
        }
        columns={columns}
        loading={loading}
        rowKey={rowKey}
        title={title ? () => title : undefined}
    />
);

export default PlatformTable;
